export default (state: any) => {
  return {
    ...state,
    shell: {
      sidenavIsShown: false,
      drawerIsShown: false,
    },
  };
};
